import React, { Fragment } from "react";

import Header from "../../components/header/header";

import "./contact.scss";

const Contact = () => (
  <Fragment>
    <Header />
    <section className="page_container">
      <div className="contact_section">
        <p>
          PIRENTZ PRIVATE LIMITED
          <br />
          H. NO. HIG- 158 DUPLEX, M.P. HOUSING BOARD, AYODHYA NAGAR EXTENSION,
          <br />
          BHOPAL, Bhopal, Madhya Pradesh, 462041
          <br />
          Phone: 1 800 120 6969
        </p>
      </div>
    </section>
  </Fragment>
);

export default Contact;
